import styled from '@emotion/styled';

import { MediaBP } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';
import { css } from '@emotion/react';

export const Container = styled.div`
  width: fit-content;
  ${flex('column', 'start', 'start')};
`;

export const Icon = styled.img<{ active?: boolean }>`
  height: 16px;
  ${(props) => props.active && ' filter: invert(1) brightness(0);'};
  ${MediaBP.MediaXl} {
    height: 18px;
  } ;
`;

export const autoHeight = css`
  height: auto;
`;
